(ns frontend.view.modals.curtains.fundraising-opportunity.events
  (:require [common.localization :as loc]
            [frontend.view.modals.events :as modals]
            [frontend.view.modals.confirmation.view :as confirmation-modal]
            [frontend.view.modals.error-message.view :as error-message]
            [frontend.logging :as logging]
            [frontend.actions.fundraising-opportunity :as fundraising-opportunity-actions]))

(defn confirm-loss [state fundraising-opportunity close-modal!]
  (let [confirm-text (loc/tr :fundraising-opportunity-loss-curtains/confirm)]
    (modals/open-modal!
     confirmation-modal/modal-key
     {:body         [:div.text-center
                     [:p confirm-text]]
      :confirm-text (loc/tr :confirm)
      :confirm-icon ""
      :skip-checkbox? true
      :on-confirm   (fn [_]
                      (fundraising-opportunity-actions/*->lost!
                       {:fundraising-opportunity-id (:db/id fundraising-opportunity)
                        :loss-reason-id             (:fundraising-opportunity/lost-reason (:edit @state))
                        :loss-comment               (:internal-comment (:edit @state))}
                       (fn [_]
                         (close-modal!))
                       (fn [{:keys [error message] :as err}]
                         (let [error-message (cond (string? message) message
                                                   (keyword? error) (loc/tr error)
                                                   :else (loc/tr :unknown-error-persists))]
                           (modals/open-modal!
                            error-message/modal-key
                            {:title (loc/tr :attention)
                             :body-content error-message
                             :ok-button-text (loc/tr :ok)}))
                         (logging/error "Failed to set froppo status to lost" err))))})))

(defn confirm-on-hold [state fundraising-opportunity close-modal!]
  (let [edits (:edit @state)
        {:keys [months until internal-comment]} edits
        until (if (zero? months)
                until
                months)
        confirm-text (loc/tr :fundraising-opportunity-on-hold-curtains/confirm)]
    (modals/open-modal!
     confirmation-modal/modal-key
     {:body          [:div.text-center
                      [:p confirm-text]]
      :confirm-text  (loc/tr :confirm)
      :confirm-icon  ""
      :skip-checkbox? true
      :title         (loc/tr :submit)
      :on-confirm    (fn [_]
                       (fundraising-opportunity-actions/*->put-on-hold
                        {:fundraising-opportunity-id (:db/id fundraising-opportunity)
                         :on-hold-until              until
                         :on-hold-comment            internal-comment}
                        (fn [_]
                          (close-modal!))
                        (fn [err]
                          (logging/error "Failed to set froppo status to on hold" err))))})))
